/**
 * Simple hash function (djb2) - fast, deterministic, good distribution
 * Used for generating fixed-length identifiers from variable-length strings
 */
export const hashString = (str: string): string => {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return (hash >>> 0).toString(16);
};
